import { springboardAPI } from "src/boot/axios"
import { SpringboardURL } from "src/util/enums/urls"
import { concatUrl, getCustomConfig, getNewAbortHandler } from "src/util/http/httpHelper"
import { HttpConfig } from "src/util/types/dataModels/http"
import {
  PERMISSION_ACCESS_READ,
  PERMISSION_WORKSPACES,
  UserBasic,
} from "src/util/types/dataModels/user"
import { WorkspaceDetail, WorkspaceUserFilterParams } from "src/util/types/dataModels/workspace"

/**
 * The following endpoints are springboard and not CSI
 */

/**
 * Returns the list of workspaces for the user
 */
export async function getWorkspaceList(config: HttpConfig = {}): Promise<WorkspaceDetail[]> {
  const url = SpringboardURL.WORKSPACES_LIST
  const abortHandler = config?.abortHandler || getNewAbortHandler("GET", url)
  const customConfig = getCustomConfig(abortHandler, PERMISSION_WORKSPACES, PERMISSION_ACCESS_READ)
  const signal = abortHandler.controller.signal

  const { data } = await springboardAPI.get(url, { signal, customConfig })

  return data
}

/**
 * Returns the workspace data for the given workspace id
 *
 * @param config
 * @param workspaceId
 */
export async function getWorkspace(
  config: HttpConfig = {},
  workspaceId: string
): Promise<WorkspaceDetail> {
  const url = SpringboardURL.WORKSPACES_ID.replace("{id}", workspaceId)
  const abortHandler = config?.abortHandler || getNewAbortHandler("GET", url)
  const customConfig = getCustomConfig(abortHandler, PERMISSION_WORKSPACES, PERMISSION_ACCESS_READ)
  const signal = abortHandler.controller.signal

  const { data } = await springboardAPI.get(url, { signal, customConfig })

  return data
}

/**
 * Returns the users for a given workspace.
 *
 * @param config
 * @param workspaceId
 */
export async function getUsersForWorkspace(
  config: HttpConfig<WorkspaceUserFilterParams> = {},
  workspaceId: string
): Promise<UserBasic[]> {
  const entityURL = SpringboardURL.WORKSPACES_ID_USERS.replace("{id}", workspaceId)
  const url = concatUrl(entityURL, { ...config?.mainParams, ...config?.filterParams })
  const abortHandler = config?.abortHandler || getNewAbortHandler("GET", url)
  const customConfig = getCustomConfig(abortHandler, PERMISSION_WORKSPACES, PERMISSION_ACCESS_READ)
  const signal = abortHandler.controller.signal

  const { data } = await springboardAPI.get(url, { signal, customConfig })

  return data
}
